import { __read } from "tslib";
import { lazy } from 'react';
var LazyEdgeWorthDataSourceManager = lazy(function () { return import('./edgeworth/EdgeworthDataSourceManager'); });
var LazyRecommendedFeedDataSourceManager = lazy(function () { return import('./RecommendedDataSourceManager'); });
var LazyODSPMediaDataSourceManager = lazy(function () { return import('./odsp/ODSPMediaDataSourceManager'); });
export var DataSourceInfo = {
    edgeworth: {
        dataTypes: new Set(['recent']),
        LazyManager: LazyEdgeWorthDataSourceManager,
    },
    'recommended-files-api': {
        dataTypes: new Set(['recommended']),
        LazyManager: LazyRecommendedFeedDataSourceManager,
    },
    odsp: {
        dataTypes: new Set(['media']),
        LazyManager: LazyODSPMediaDataSourceManager,
    },
};
export var DataTypeToSource = Object.entries(DataSourceInfo).reduce(function (acc, _a) {
    var _b = __read(_a, 2), source = _b[0], config = _b[1];
    config.dataTypes.forEach(function (dataType) {
        acc[dataType].add(source);
    });
    return acc;
}, {
    media: new Set(),
    recent: new Set(),
    recommended: new Set(),
});
//# sourceMappingURL=managers.js.map